export default __webpack_public_path__ + "static/media/money-printing.6966e653.gif";